module.exports = __webpack_public_path__ + "img/photo-2.a4ab4d19.webp";